import React from 'react';
import { connect } from 'react-redux';
// import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle'; // substituted by custom
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

// import DialogTitle from 'components/DialogTitle';
import { deletePosition } from '../store/positions.slice';
import { openDialog, closeDialog } from '../store/discuss.slice';

const useStyles = makeStyles(theme => ({
  root: {
    // border: 'solid black 1px', // DEBUG
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function PositionDelete(props) {
  const {
    show,
    // position,
    // pending, // @todo
    // error,
    openDialog,
    onOpen,
    onClose,
    onDelete,
  } = props;
  const classes = useStyles();

  const buildTrigger = () => (
    <IconButton
      size="small"
      color="inherit"
      aria-label="Delete position"
      onClick={onOpen}
    >
      <DeleteIcon />
    </IconButton>
  );

  const buildActions = () => (<>
    <Button
      variant="contained"
      size="small"
      onClick={onClose}
    >Cancel</Button>
    <Button
      variant="contained"
      color="secondary"
      size="small"
      // className={classes.button}
      startIcon={<DeleteIcon />}
      onClick={onDelete}
    >Delete</Button>
  </>);

  // console.log('PositionDimensionsCast', props); // DEBUG

  return (
    <div className={classes.root}>
      {show && buildTrigger()}
      <Dialog
        open={openDialog}
        // maxWidth="md"
        fullWidth={true}
        onClose={onClose}
      >
        {/* <DialogTitle onClose={handleClose}>Cognitive ranking for the position</DialogTitle> */}
        <DialogContent>
          Do you really want delete this position?
        </DialogContent>
        <DialogActions>
          {buildActions()}
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const position = ownProps.position;
  const dialogState = state.discuss.layout.dialogs;
  // const authUser = state.auth.profile;
  const uid = _.get(state.auth.profile, 'uid', false);

  // @todo move in a selectort ?
  const agreementsState = state.discuss.positionAgreements;
  const thumbsState = state.discuss.positionThumbs;
  const heartsState = state.discuss.positionHearts;
  const dimensionsState = state.discuss.positionDimensions;
  const claimsState = state.discuss.claims;

  return {
    openDialog: dialogState.positionDelete === position.id,
    show: uid === position.metadata.createdBy
      && !_.has(agreementsState, `byId[${position.id}]`)
      && !_.has(thumbsState, `byId[${position.id}]`)
      && !_.has(heartsState, `byId[${position.id}]`)
      && !_.has(dimensionsState, `byId[${position.id}]`)
      && !_.has(claimsState, `byPosition[${position.id}]`)
      ,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const position = ownProps.position;
  return {
    onDelete: () => {
      return dispatch(deletePosition(position))
        .then(res => {
          if (res.meta.requestStatus === 'fulfilled') {
            dispatch(closeDialog('positionDelete'));
          }
          return res;
        });
    },
    onOpen: () => dispatch(openDialog({
      resourceName: 'positionDelete',
      resourceId: position.id,
    })),
    onClose: () => dispatch(closeDialog('positionDelete')),
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionDelete);
